import * as Sentry from '@sentry/nextjs'

export const loadSentry = async (dsn, config) =>
  new Promise((resolve, reject) => {
    try {
      Sentry.init({
        dsn,
        ...config
      })
      resolve()
    } catch (error) {
      reject(error)
    }
  })
